import { render, staticRenderFns } from "./subjectinfo-add-or-update.vue?vue&type=template&id=e5481f6e&scoped=true"
import script from "./subjectinfo-add-or-update.vue?vue&type=script&lang=js"
export * from "./subjectinfo-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./subjectinfo-add-or-update.vue?vue&type=style&index=0&id=e5481f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5481f6e",
  null
  
)

export default component.exports